import React from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.scss";
import logo from "../../assets/logo.png";
import dashboard from "../../assets/images/sidebar/dashboard.svg";
import contentManagement from "../../assets/images/sidebar/content-management.svg";
import forms from "../../assets/images/sidebar/forms.svg";
// import logs from "../../assets/images/sidebar/logs.svg";
// import report from "../../assets/images/sidebar/report.svg";
// import roles from "../../assets/images/sidebar/roles.svg";
// import support from "../../assets/images/sidebar/support.svg";
// import ticket from "../../assets/images/sidebar/ticket.svg";
// import hestailogo from "../../assets/transp.png";

const AdminSidebar = () => {
  const d = new Date();
  let year = d.getFullYear();
  return (
    <div className="sidebar">
      <div className="sidebar-inner">
        <div className="logo">
          <img
            src={logo}
            width="300px"
            height="100px"
            className="sidebar-logo"
          />
        </div>
        <div className="module-name">Admin</div>
        <div className="menu-links">
          <ul>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/admin/dashboard"
              >
                <img src={dashboard} />
                <span>User's</span>
              </NavLink>
            </li>
             <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/admin/usermanagement"
              >
                <img src={dashboard} />
                <span>User's Management</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/admin/MostActiveUsers"
              >
                <img src={dashboard} />
                <span>Most Active Users</span>
              </NavLink>
            </li>
            
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/admin/send-notification"
              >
                <img src={dashboard} />
                <span>Send Notification</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/admin/questionnaire-management"
              >
                <img src={dashboard} />
                <span>Questionnaire Management</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/admin/content-management"
              >
                <img src={contentManagement} />
                <span>Content Management</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/admin/forms"
              >
                <img src={forms} />
                <span>Connect Management Screen</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/admin/user/tobeverifed"
              >
                <img src={forms} />
                <span>User Request List</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/admin/notifications"
              >
                <img src={forms} />
                <span>Notifications</span>
              </NavLink>
            </li>

            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/admin/report"
              >
                <img src={forms} />
                <span>Reported Bugs</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/admin/subscription"
              >
                <img src={forms} />
                <span>Subscription Plans</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/admin/payment/history"
              >
                <img src={forms} />
                <span>Payment History</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/admin/job-management"
              >
                <img src={forms} />
                <span>Job Management</span>
              </NavLink>
            </li>
            {/* <li>
              <NavLink className={({ isActive }) => isActive? "active": ''} to='/admin/deeplinks'>
                <img src={forms} />
                <span>Send Deeplinks</span>
              </NavLink>
            </li> */}
            {/* <li>
              <NavLink className={({ isActive }) => isActive? "active": ''} to='/admin/agents'>
                <img src={support} />
                <span>Customer Support </span>
              </NavLink>
            </li>
            <li>
              <NavLink className={({ isActive }) => isActive? "active": ''} to='/admin/tickets'>
                <img src={ticket} />
                <span>Ticket Management</span>
              </NavLink>
            </li> */}
            {/* <li>
              <NavLink className={({ isActive }) => isActive? "active": ''} to='/admin/roles'>
                <img src={roles} />
                <span>Roles and Permission</span>
              </NavLink>
            </li> */}
            {/* 
            <li>
              <NavLink activeClassName="active" to='/admin/reports'>
                <img src={report} />
                <span>Report</span>
              </NavLink>
            </li>
            <li>
              <NavLink activeClassName="active" to='/admin/logs'>
                <img src={logs} />
                <span>Logs</span>
              </NavLink>
            </li> */}
          </ul>
          <div className="bottom-text">
            <p>© {year},Liaise . All rights reserved. </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;
